export const restart = () => {
    if (process.env.REACT_APP_HUB_REDIRECT === "false") {
        window.location.reload();
        return;
    }
    window.location.href = process.env.REACT_APP_HUB_URL || "";
};
